// Text size selector (A / A+ / A++), persisted per browser.
document.querySelectorAll('[data-text-size]').forEach(function (btn) {
  var current = document.documentElement.dataset.text || '0';
  btn.setAttribute('aria-pressed', btn.dataset.textSize === current);
  btn.addEventListener('click', function () {
    var v = btn.dataset.textSize;
    if (v === '0') delete document.documentElement.dataset.text;
    else document.documentElement.dataset.text = v;
    try { localStorage.setItem('lv-text', v); } catch (e) {}
    document.querySelectorAll('[data-text-size]').forEach(function (b) {
      b.setAttribute('aria-pressed', b === btn);
    });
  });
});

// Product gallery: thumbnails show the matching image or video; a hidden video stops playing.
document.querySelectorAll('[data-gallery]').forEach(function (g) {
  g.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
    t.addEventListener('click', function () {
      g.querySelectorAll('[data-gallery-item]').forEach(function (item) {
        var show = item.dataset.galleryItem === t.dataset.galleryThumb;
        if (!show && !item.hidden) {
          item.querySelectorAll('video').forEach(function (v) { v.pause(); });
          item.querySelectorAll('iframe').forEach(function (f) { f.src = f.src; });
        }
        item.hidden = !show;
      });
      g.querySelectorAll('[data-gallery-thumb]').forEach(function (o) {
        o.setAttribute('aria-current', o === t);
      });
    });
  });
});

// Pack selector: keep URL ?variant= and visible price in sync so COD apps pick the right variant.
document.querySelectorAll('[data-packs]').forEach(function (fs) {
  fs.addEventListener('change', function (e) {
    var input = e.target;
    // Packs that are separate products open their own page, so COD form apps load that product.
    if (input.dataset.url) return location.assign(input.dataset.url);
    var url = new URL(location.href);
    url.searchParams.set('variant', input.value);
    history.replaceState(null, '', url);
    document.querySelectorAll('[data-product-price]').forEach(function (p) {
      p.innerHTML = input.dataset.priceHtml;
    });
  });
});

// Reviews: show the real average next to the product title and expand the full list on demand.
(function () {
  var reviews = document.querySelector('[data-reviews]');
  var slot = document.querySelector('[data-rating-slot]');
  if (reviews && slot && Number(reviews.dataset.count) > 0) {
    var n = Number(reviews.dataset.count);
    var pct = parseFloat(reviews.dataset.avg.replace(',', '.')) * 20;
    slot.innerHTML = '<span class="stars-meter" style="--pct:' + pct + '%" aria-hidden="true"></span> <span>' + reviews.dataset.avg +
      ' · ' + n + (n === 1 ? ' reseña' : ' reseñas') + '</span>';
    slot.hidden = false;
  }
  var more = document.querySelector('[data-reviews-more]');
  if (more) more.addEventListener('click', function () {
    document.querySelector('[data-reviews-list]').classList.add('is-open');
    more.hidden = true;
  });
})();

// Sticky mobile buy bar: show once the main buy area scrolls out of view.
var buy = document.getElementById('comprar');
var bar = document.querySelector('[data-sticky-buy]');
if (buy && bar && 'IntersectionObserver' in window) {
  new IntersectionObserver(function (entries) {
    bar.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
  }).observe(buy);
}

// Cart sticky bar: shown while the summary's order button is off screen. It presses the COD app's
// cart button when the app added one, otherwise the theme's checkout button.
var cartCta = document.querySelector('.cart-cta');
var cartBar = document.querySelector('[data-cart-sticky]');
if (cartCta && cartBar) {
  cartBar.querySelector('button').addEventListener('click', function () {
    (cartCta.querySelector('#cart-wrapper button') || cartCta.querySelector('[name="checkout"]')).click();
  });
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      cartBar.classList.toggle('is-visible', !entries[0].isIntersecting);
    }).observe(cartCta);
  }
}

// Advisor popup: opens once per browser, after the visitor scrolls past data-scroll percent of the page.
// A visitor who already pressed the COD app's order button counts as served, so the popup never shows
// up over the order form. ?asesor=1 opens it right away, for testing.
var agentPop = document.querySelector('[data-agent-pop]');
if (agentPop && typeof agentPop.showModal === 'function') {
  var agentKey = 'lv-agent-seen';
  var agentForced = /[?&]asesor=1/.test(location.search);
  var agentSeen = function () {
    try { return localStorage.getItem(agentKey); } catch (e) { return '1'; }
  };
  var agentMarkSeen = function () {
    try { localStorage.setItem(agentKey, String(Date.now())); } catch (e) {}
    window.removeEventListener('scroll', agentOnScroll);
  };
  var agentOpen = function () {
    // The COD app locks body scroll while its form is open.
    if (document.querySelector('dialog[open]') || getComputedStyle(document.body).overflow === 'hidden') return;
    agentMarkSeen();
    agentPop.showModal();
  };
  var agentOnScroll = function () {
    var max = document.documentElement.scrollHeight - window.innerHeight;
    var share = (parseInt(agentPop.dataset.scroll, 10) || 50) / 100;
    if (max > 0 && window.scrollY / max >= share) agentOpen();
  };
  // A click on the dark backdrop lands on the dialog itself, outside its inner box.
  agentPop.addEventListener('click', function (e) {
    if (e.target === agentPop || e.target.closest('[data-agent-go]')) agentPop.close();
  });
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('#rsi_buy_now_button, #cart-wrapper')) agentMarkSeen();
  }, true);
  if (agentForced) agentOpen();
  else if (!agentSeen()) window.addEventListener('scroll', agentOnScroll, { passive: true });
}
